import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import ErrorView from 'src/sections/react-error-boundary/view';

// sections

// ----------------------------------------------------------------------

export default function ErrorPage({ resetErrorBoundary }) {
  return (
    <>
      {/* <Header /> */}

      <Container component="main">
        <Stack
          sx={{
            m: 'auto',
            maxWidth: 800,
            minHeight: '90vh',
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          <ErrorView resetErrorBoundary={resetErrorBoundary} />
        </Stack>
      </Container>
    </>
  );
}
